import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bianji",
  "use": "icon-bianji-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bianji\">\n<path d=\"M7.79133 2.20898H3C2.44772 2.20898 2 2.6567 2 3.20898V12.7916C2 13.3439 2.44771 13.7916 3 13.7916H12.5827C13.1349 13.7916 13.5827 13.3439 13.5827 12.7916V8.00032\" stroke-width=\"1.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<line x1=\"5.5625\" y1=\"9.73115\" x2=\"13.084\" y2=\"2.20965\" stroke-width=\"1.3\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol